import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=60f57956&scoped=true&"
import script from "./upload.vue?vue&type=script&lang=js&"
export * from "./upload.vue?vue&type=script&lang=js&"
import style0 from "./upload.vue?vue&type=style&index=0&id=60f57956&prod&lang=css&"
import style1 from "./upload.vue?vue&type=style&index=1&id=60f57956&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f57956",
  null
  
)

export default component.exports